import service from './index'

export const apiGetCaptcha = () => service.get('/Sso/VerifyCode');

export const apiGetIDasImageCode = () => service.post('/Sso/GetIDassImageCode');

export const apiSendSecondValidateCode = (info) => service.post("/Sso/SendIDassCode",info)

export const apiGetIPV4 = () => service.get('/Sso');

export const apiGetIP = () => service.get('/Sso/GetIP');

export const apiLogin = (info) => service.post('/Sso/login', info);

export const apiSSOLogin = (info) => service.post('sso/SSOLogin',info);

export const apiPhoneLogin = (info) => service.post('/Sso/PhoneCodeLogin',info)

export const apiCheckImageCode = (info) => service.post('/Sso/CheckImageCode', info);

export const apiCheckPhoneCode = (info) => service.post('/Sso/CheckPhoneCode', info);

export const apiSendPhoneCode = (info) => service.post('/Sso/PhoneCode', info);

export const apiUpdatePassword = (info) => service.post('/Sso/UpdatePwd', info);
